/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoElecCtrInfo {
    /**
     * 送配電事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C020960」のユーザコードを設定
     */
    transCode?: string;
    /**
     * 送配電事業者コード名称：全半角混在
     */
    transCodeAname?: string;
    /**
     * 電圧区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C020970」のユーザコードを設定
     */
    voltDiv?: string;
    /**
     * 電圧区分名称：全半角混在
     */
    voltDivAname?: string;
    /**
     * 申込種別：英数字<br>　コード変換マスターテーブル.画面項目ID「C403050」のユーザコードを設定
     */
    srnClsfy?: string;
    /**
     * 申込種別名称：全半角混在
     */
    srnClsfyAname?: string;
    /**
     * 供給地点特定番号：数字
     */
    suppntSpno?: string;
    /**
     * 接続送電サービスメニューコード：英数字<br>　コード変換マスターテーブル.画面項目ID「C021062」のユーザコードを設定
     */
    transMnucod?: string;
    /**
     * 接続送電サービスメニューコード名称：全半角混在
     */
    transMnucodAname?: string;
    /**
     * 契約決定方法コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300060」のユーザコードを設定
     */
    ctrdcsCode?: string;
    /**
     * 契約決定方法コード名称：全半角混在
     */
    ctrdcsCodeAname?: string;
    /**
     * 廃止理由区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C403100」のユーザコードを設定
     */
    ablitnRsncod?: string;
    /**
     * 廃止理由区分コード名称：全半角混在
     */
    ablitnRsncodAname?: string;
    /**
     * 建物解体有無フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C403110」のユーザコードを設定
     */
    dmntrdEonflg?: string;
    /**
     * 建物解体有無フラグ名称：全半角混在
     */
    dmntrdEonflgAname?: string;
    /**
     * 建物解体予定日付：日付(yyyyMMdd)
     */
    dmntrdScdDate?: string;
    /**
     * 建物解体予定時刻：英数字<br>　コード変換マスターテーブル.画面項目ID「C401081」のユーザコードを設定
     */
    dmntrdStimez?: string;
    /**
     * 建物解体予定時刻名称：全半角混在
     */
    dmntrdStimezAname?: string;
    /**
     * 現小売事業者コード：英数字
     */
    oldretCode?: string;
    /**
     * 現小売事業者コード名称：全角
     */
    oldretAname?: string;
    /**
     * 廃止取次番号：数字
     */
    ablcomNo?: string;
    /**
     * 現小売事業者契約番号：英数字
     */
    oldretCtrNo?: string;
    /**
     * 基本検針日：数字
     */
    basicKensinDay?: string;
    /**
     * 力率
     */
    powerPrcent?: number;
    /**
     * 供給電圧区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C021071」のユーザコードを設定
     */
    supVltdiv?: string;
    /**
     * 供給電圧区分コード名称：全半角混在
     */
    supVltdivAname?: string;
    /**
     * 検針区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C403321」のユーザコードを設定
     */
    meterDiv?: string;
    /**
     * 検針区分名称：全半角混在
     */
    meterDivAname?: string;
    /**
     * 約款別パターン：英数字<br>　コード変換マスターテーブル.画面項目ID「D400040」のユーザコードを設定
     */
    stiPtn?: string;
    /**
     * 約款別パターン名称：全半角混在
     */
    stiPtnAname?: string;
}

